import React, {MutableRefObject } from "react";
import { PolicyModuleProps } from "@/pages/policy/ProductPolicyApply/data";
import {WdiPanel} from "@/components/WdiControls/WdiPanel";
import {WdiCardTitle, WdiInput} from "@/components/WdiControls";
import {Enum} from "@/enums/system";
import {Col, Form, Row} from "antd";
import RebateStandardApp from "@/pages/policy/ProductPolicyApply/components/rebateStandard";
import {OpenModeEnum} from "@/pages/policy/ProductPolicyApply/components/apply";

type BasicReplenishDetailProps = {
  formRef: MutableRefObject<any>,
  policyModuleData?: PolicyModuleProps,
  readonlyFields?: string[],
  openMode?: OpenModeEnum
  entity?: any;
};

const ProductPolicyDetailApprovalPanel: React.FC<BasicReplenishDetailProps> = (props: BasicReplenishDetailProps) => {
  return (
    <WdiPanel collapsed={true} title={ <WdiCardTitle iconType={ Enum.IconType.BASE_INFO} title={ '政策条款' }/>}>
      <Row gutter={[16, 0]}>
        <Col className="gutter-row" span={4} key="productIdsReach">
          <Form.Item
            name="productNamesReach"
            label="达量产品"
          >
            <WdiInput readOnly />
          </Form.Item>
        </Col>

        <Col className="gutter-row" span={4} key="productIdsRebate">
          <Form.Item
            name="productNamesRebate"
            label="返利产品"
          >
            <WdiInput readOnly />
          </Form.Item>
        </Col>

        <Col className="gutter-row" span={4} key="productIdsReachEx">
          <Form.Item
            name="productNamesReachEx"
            label="排除达量产品"
          >
            <WdiInput readOnly />
          </Form.Item>
        </Col>

        <Col className="gutter-row" span={4} key="productIdsRebateEx">
          <Form.Item
            name="productNamesRebateEx"
            label="排除返利产品"
          >
            <WdiInput readOnly />
          </Form.Item>
        </Col>

        <Col className="gutter-row" span={4} key="settlementFrequency">
          <Form.Item
            name="settlementFrequencyName"
            label="结案频率"
          >
            <WdiInput readOnly />
          </Form.Item>
        </Col>

        <Col className="gutter-row" span={4} key="paymentMethod">
          <Form.Item
            name="paymentMethodName"
            label="支付方式"
          >
            <WdiInput readOnly />
          </Form.Item>
        </Col>

        {
          //支付方式为货补池(经销商)、搭赠池(经销商)时才显示指定货补产品别
          props.entity?.productIdsFg &&
          [Enum.PaymentMethod.FG_POOL, Enum.PaymentMethod.BUY_GIVE_POOL].includes(props.entity?.paymentMethod) &&
          <Col className="gutter-row" span={4} key="productNamesFg">
            <Form.Item
              name="productNamesFg"
              label="指定货补产品别"
            >
              <WdiInput readOnly />
            </Form.Item>
          </Col>
        }

        <Col className="gutter-row" span={24}>
          <Form.Item
            name="rebateStandard"
            label={'返利标准'}
          >
            <RebateStandardApp openMode={OpenModeEnum.VIEW} />
          </Form.Item>
        </Col>
      </Row>
    </WdiPanel>
  );
}

export default ProductPolicyDetailApprovalPanel;
